import Content from './content-interface';

export default class SetInstanceDateChangedHistory implements Content {
  instance: string;

  previousStartedAt: string;

  newStartedAt: string;

  constructor(obj: any = {}) {
    this.instance = obj.instance || '';
    this.previousStartedAt = obj.previousStartedAt || '';
    this.newStartedAt = obj.newStartedAt || '';
  }

  public static of(obj: any = {}): SetInstanceDateChangedHistory {
    return new SetInstanceDateChangedHistory(obj);
  }
}
